import { render, staticRenderFns } from "./PlacementRecommendTableForm.vue?vue&type=template&id=1880d624&scoped=true"
import script from "./PlacementRecommendTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementRecommendTableForm.vue?vue&type=script&lang=js"
import style0 from "./PlacementRecommendTableForm.vue?vue&type=style&index=0&id=1880d624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880d624",
  null
  
)

export default component.exports